module.exports = __webpack_public_path__ + "fonts/Poppins-Medium.3b48234d.woff2";